export const HANDLE_FIELD_STATUS_UPDATE = 'errorForm/HANDLE_FIELD_STATUS_UPDATE';
export const UPDATE_FIELD_STATUS = 'errorForm/UPDATE_FIELD_STATUS';
